import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { LegacyStack, Text } from '@shopify/polaris';
import Address from './Address'
import ProxyForm from '../ProxyForm'
import EditPassword from '../../EditPassword'
import EditContact from '../../EditContact'
import { CustomerContext } from '../../contexts/Customer'
import { ShopContext } from '../../contexts/Shop'
import { HostContext } from '../../contexts/Host'
import { FormProvider, useFetch, Util } from '@thinkwell/react.common'
import { ProductsContext } from "../../contexts/Products";
import { ProductsYolkContext } from "../../contexts/yolk/Products";
import { Spinner } from "@thinkwell/react.polaris";
import { UserContext } from "../../contexts/yolk/User";
import { EnrollmentsContext } from "../../contexts/yolk/Enrollments";
import { SubscriptionsContext } from "../../contexts/Subscriptions";
import ResourceGroup from "./ResourceGroup";

export default function Resources(props) {
  const host = useContext(HostContext)
  const [products] = useContext(ProductsContext)
  const subscriptions = useContext(SubscriptionsContext)
  const [user] = useContext(UserContext)
  const [productsYolk, fetchProductsYolk, fetchProductsYolkState] = useContext(ProductsYolkContext)

  useEffect(() => {
    if(products && products.length && !productsYolk.length) {
      fetchProductsYolk(`${host}/accounts/products.json`, {sku: products.map(product => product.sku), include_resources: true});
    }
  }, [])

  if (fetchProductsYolkState.loading) {
    return <Spinner active={true} />
  }

  // get all subscriptions for a sku that have an active enrollment
  const getActiveSubscriptions = (sku) => {
    return subscriptions.filter((subscription) => subscription.sku === sku &&
        subscription.enrollment && subscription.enrollment.isActive)
  }

  // is resource#parent_only = false or assigned to a parent?
  const isResourceValid = (resource, sku) => {
    if(!resource.parent_only) {
      return true
    }
    const subscriptions = getActiveSubscriptions(sku)
    return subscriptions.find((subscription) => !subscription.enrollment.isAssignedToUser(user) ||
        (subscription.enrollment.isAssignedToUser(user) && subscription.enrollment.ownedByUser(user)))
  }

  const productsValid = (productsYolk || []).filter(productYolk => {
    const hasValidResources = (productYolk.resource_groups || [])
        .filter(resource_group => {
          return (resource_group.resources || []).filter(resource => isResourceValid(resource, productYolk.sku)).length
    } ).length
    const hasActiveSubscriptions = getActiveSubscriptions(productYolk.sku).length

    return hasValidResources && hasActiveSubscriptions
  })
  if (!productsValid.length) {
    return <Text as="span" fontWeight="semibold">No Resources Available</Text>
  }

  return (<table style={{width: "100%"}}><tbody>
  {
    productsValid.map(productYolk => {
    return (<tr key={productYolk.id}><td><div className="row">
      <div className="columns large-6">
        <h2><Text as="span" fontWeight="semibold">{productYolk.title}</Text></h2>
        <LegacyStack vertical={true}>
          {
            (productYolk.resource_groups
                .sort((a, b) => b.is_default - a.is_default)
                .map(resource_group => {
                  const resources = resource_group.resources.filter(resource => isResourceValid(resource, productYolk.sku));
                  return resources && resources.length ? <ResourceGroup resource_group={resource_group} resources={resources}/> : null
            }))}
        </LegacyStack>
      </div>
    </div></td></tr>)
    })}
    </tbody></table>)
}
